module.exports = __webpack_public_path__ + "img/temp-viewer-icon.e89556db.svg";